module.exports = __webpack_public_path__ + "static/media/9.e6fe380b.mp3";